var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4916 16.6014C14.8217 16.6014 15.0889 16.879 15.0889 17.2218C15.0889 17.564 14.8216 17.8416 14.4916 17.8416L3.93031 17.8415C3.60065 17.8415 3.33337 17.5639 3.33337 17.2216C3.33337 16.8789 3.60063 16.6013 3.93031 16.6013H14.4916V16.6014ZM3.90238 15.7647L5.33714 11.7856L7.67531 14.2141L3.90238 15.7647ZM8.15471 13.7566L5.79655 11.3081L12.2069 4.70397L14.5651 7.15233L8.15471 13.7566ZM15.0051 6.64373L12.647 4.19524L13.8265 2.971C14.2174 2.56566 14.8501 2.56566 15.2409 2.971L16.1841 3.95028C16.5749 4.35609 16.5749 5.01415 16.1841 5.41995L15.0051 6.64373Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/EditProfile.cd3189d29a0785ddbdb37096c10b38a4.svg";
export { ForwardRef as ReactComponent };